import detail from "../components/detail.vue"
import LiveShare from "../components/LiveShare.vue"
import PicShare from "../components/PicShare.vue"
import UserAgreement from "../components/UserAgreement.vue"
import AnchorAgreement from "../components/AnchorAgreement.vue"
import Privacy from "../components/Privacy.vue"
import LogoutNotice from "../components/LogoutNotice.vue"
import SdkNotice from "../components/SdkNotice.vue"
import FeedBack from "../components/FeedBack.vue"
import FeedBackDetail from "../components/FeedBackDetail.vue"
import TipOff from "../components/TipOff.vue"
import TipOffDetail from "../components/TipOffDetail.vue"
import Download from "../components/Download.vue"
import Banner from "../components/Banner.vue"
import JoinUs from "../components/JoinUs.vue"
import OpenLimit from "../components/OpenLimit.vue"
import OpenType from "../components/OpenType.vue"
import OpenInfo from "../components/OpenInfo.vue"
export default [{
  path: '/detail',
  component: detail
}, {
  path: '/liveShare',
  component: LiveShare
}, {
  path: '/picShare',
  component: PicShare
}, {
  path: '/userAgreement',
  component: UserAgreement,
  meta: {
    title: '用户协议'
  }
}, {
  path: '/anchorAgreement',
  component: AnchorAgreement
}, {
  path: '/privacy',
  component: Privacy,
  meta: {
    title: '隐私政策'
  }
}, {
  path: '/logout-notice',
  component: LogoutNotice,
  meta: {
    title: '探店注销须知'
  }
}, {
  path: '/sdk-notice',
  component: SdkNotice,
  meta: {
    title: '第三方SDK目录'
  }
}, {
  path: '/feedBack',
  component: FeedBack,
  meta: {
    title: '反馈与帮助'
  }
}, {
  path: '/feedBackDetail/:id',
  component: FeedBackDetail
}, {
  path: '/tip-off',
  component: TipOff
}, {
  path: '/tip-off-detail',
  component: TipOffDetail
}, {
  path: '/download',
  component: Download
}, {
  path: '/banner',
  component: Banner
}, {
  path: '/join-us',
  component: JoinUs
}, {
  path: '/open-limit',
  component: OpenLimit,
  meta: {
    title: '申请说明'
  }
}, {
  path: '/open-type',
  component: OpenType,
  meta: {
    title: '开通小店'
  }
}, {
  path: '/open-info',
  component: OpenInfo,
  meta: {
    title: '开通小店'
  }
}]